(() => {
  'use strict';
  const configNode = document.getElementById('YGCartConfig');
  const dialog = document.getElementById('YGCartDrawer');
  if (!configNode || !dialog || window.YouGamesCart) return;
  const config = JSON.parse(configNode.textContent);
  const root = (config.root || '/').replace(/\/?$/, '/');
  const q = selector => dialog.querySelector(selector);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const money = cents => new Intl.NumberFormat(config.locale === 'es' ? 'es-CL' : config.locale, {style:'currency',currency:config.currency || 'CLP'}).format(Number(cents || 0) / 100);
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const isPlus = p => /ps[\s-]*plus|playstation[\s-]*plus/.test(normalize([p.product_type,p.type,p.product_title,p.title,p.handle,...(Array.isArray(p.tags) ? p.tags : [p.tags])].join(' ')));
  const isExcluded = p => {
    const title = normalize(p.product_title || p.title);
    return /(?:fc[\s-]*27|fc[\s-]*2027).*ultimate/.test(title) ||
      /fc.*ultimate/.test(normalize(p.handle)) ||
      String(config.excluded || '').split(',').map(x => x.trim()).filter(Boolean).includes(p.handle);
  };
  const pools = (config.pools || []).flat().filter(Boolean);
  const productCache = new Map();
  const productUrl = p => root + 'products/' + encodeURIComponent(p.handle);
  let cart = null, returnFocus = null, renderVersion = 0, queue = Promise.resolve();
  let pending = 0, recommendationMap = new Map();
  const setStatus = message => { q('[data-drawer-status]').textContent = message || ''; };
  async function request(path, options = {}) {
    const response = await fetch(root + path, {credentials:'same-origin', ...options, headers:{Accept:'application/json', ...(options.headers || {})}});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'No se pudo actualizar el carrito. Inténtalo de nuevo.');
    return data;
  }
  const post = (path, body) => request(path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
  function setBusy(value) {
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('[data-line-key], [data-recommend-add], .yg-drawer__checkout').forEach(el => { el.disabled = value; });
  }
  function serialize(task) {
    pending++;
    setBusy(true);
    const result = queue.then(task);
    queue = result.catch(() => {});
    return result.finally(() => { pending--; setBusy(pending > 0); });
  }
  function openShell() {
    if (!config.drawer) { location.assign(config.cartUrl); return false; }
    if (!dialog.open) {
      returnFocus = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('yg-drawer-open');
      document.body.classList.add('yg-drawer-open');
      q('[data-drawer-close]').focus();
    }
    return true;
  }
  function close() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('yg-drawer-open');
    document.body.classList.remove('yg-drawer-open');
    if (returnFocus?.isConnected) returnFocus.focus();
    document.dispatchEvent(new CustomEvent('cart:closed'));
  });
  q('[data-drawer-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
  function renderCart(data) {
    cart = data;
    const count = data.item_count;
    q('[data-drawer-count]').textContent = '(' + count + ')';
    q('[data-drawer-total]').textContent = money(data.total_price);
    q('[data-drawer-footer]').hidden = !count;
    document.querySelectorAll('#yg-cart-count, [data-yg-cart-count]').forEach(el => { el.textContent=count; el.style.display=count ? '' : 'none'; });
    q('[data-drawer-items]').innerHTML = !count
      ? '<div class="yg-drawer__empty"><h3>Tu próxima aventura te espera</h3><p>Aún no tienes productos en el carrito.</p><a href="'+escape(config.catalogUrl)+'">Explorar juegos</a></div>'
      : data.items.map(item => {
        const properties = Object.entries(item.properties || {}).filter(([k,v]) => !k.startsWith('_') && v);
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        return '<article class="yg-drawer__item">' +
          (item.image ? '<a href="'+escape(item.url)+'"><img class="yg-drawer__image" src="'+escape(item.image)+'" alt="'+escape(item.product_title)+'" width="72" height="94"></a>' : '<div></div>') +
          '<div><a class="yg-drawer__name" href="'+escape(item.url)+'">'+escape(item.product_title)+'</a>' +
          (variant ? '<p class="yg-drawer__variant">'+escape(variant)+'</p>' : '') +
          (properties.length ? '<p class="yg-drawer__properties">'+properties.map(([k,v]) => escape(k)+': '+escape(v)).join('<br>')+'</p>' : '') +
          (item.selling_plan_allocation ? '<p class="yg-drawer__variant">'+escape(item.selling_plan_allocation.selling_plan.name)+'</p>' : '') +
          '<div class="yg-drawer__item-price">'+money(item.final_line_price)+(item.original_line_price > item.final_line_price ? '<s>'+money(item.original_line_price)+'</s>' : '')+'</div>' +
          (item.line_level_discount_allocations || []).map(d => '<p class="yg-drawer__variant">'+escape(d.discount_application.title)+'</p>').join('') +
          '<div class="yg-drawer__actions"><div class="yg-drawer__quantity">' +
          '<button type="button" data-line-key="'+escape(item.key)+'" data-quantity="'+Math.max(0,item.quantity-1)+'" aria-label="Reducir cantidad de '+escape(item.product_title)+'">−</button>' +
          '<input type="number" min="0" step="1" value="'+item.quantity+'" data-line-key="'+escape(item.key)+'" aria-label="Cantidad de '+escape(item.product_title)+'">' +
          '<button type="button" data-line-key="'+escape(item.key)+'" data-quantity="'+(item.quantity+1)+'" aria-label="Aumentar cantidad de '+escape(item.product_title)+'">+</button></div>' +
          '<button type="button" class="yg-drawer__remove" data-line-key="'+escape(item.key)+'" data-quantity="0">Eliminar</button></div></div></article>';
      }).join('');
    setBusy(pending > 0);
    renderRecommendations(data).catch(() => { const section=q('[data-drawer-upsell]'); if(section) section.hidden=true; });
    document.dispatchEvent(new CustomEvent('yg:cart-updated',{detail:data}));
  }
  async function refresh() { const data = await request('cart.js'); renderCart(data); return data; }
  async function open() {
    if (!openShell()) return;
    setStatus('');
    try { await refresh(); } catch(error) { setStatus(error.message); }
  }
  async function add(payload, options = {}) {
    return serialize(async () => {
      setStatus('');
      let data;
      if (payload instanceof FormData) {
        payload.delete('sections'); payload.delete('sections_url');
        data = await request('cart/add.js',{method:'POST',body:payload});
      } else data = await post('cart/add.js',payload);
      if (options.checkout) { location.assign(root + 'checkout'); return data; }
      if (!config.drawer) { location.assign(config.cartUrl); return data; }
      openShell();
      try { await refresh(); } catch(error) { setStatus('Producto añadido. No pudimos cargar el resumen; abre “Ver carrito completo” para revisarlo.'); q('[data-drawer-footer]').hidden=false; }
      return data;
    });
  }
  async function change(key, quantity) {
    if (!Number.isInteger(quantity) || quantity < 0) return;
    const focusElement = document.activeElement;
    const action = focusElement?.dataset.quantity;
    return serialize(async () => {
      setStatus('');
      const data = await post('cart/change.js',{id:key,quantity});
      renderCart(data);
      const focusTarget = [...dialog.querySelectorAll('[data-line-key]')].find(el => el.dataset.lineKey === key && el.dataset.quantity === action);
      (focusTarget || q('[data-drawer-close]')).focus();
    }).catch(error => { setStatus(error.message); if(cart) renderCart(cart); });
  }
  function recentHandles() { try { return JSON.parse(localStorage.getItem('yg-recent-products') || '[]').filter(x => typeof x === 'string').slice(0,8); } catch { return []; } }
  if (config.product?.handle) {
    try { const list = [config.product.handle,...recentHandles().filter(h => h !== config.product.handle)]; localStorage.setItem('yg-recent-products', JSON.stringify(list.slice(0,8))); } catch {}
  }
  async function getProduct(handle) {
    if (!productCache.has(handle)) productCache.set(handle,request('products/'+encodeURIComponent(handle)+'.js').catch(() => null));
    return productCache.get(handle);
  }
  function rank(p) {
    const t=normalize(p.title);
    if(isPlus(p)) return /essential/.test(t) && /(?:1\s*mes\b|1\s*month\b)/.test(t) ? 0 : /extra/.test(t) && /12\s*mes/.test(t) ? 2 : /extra/.test(t) && /1\s*mes\b/.test(t) ? 3 : /essential/.test(t) && /3\s*mes/.test(t) ? 4 : 8;
    return /fc\s*27/.test(t) && !/ultimate/.test(t) ? 0 : /grand theft auto vi|gta\s*vi\b/.test(t) ? 1 : /black ops.*2|black ops.*ii\b/.test(t) ? 2 : /fc\s*26/.test(t) ? 3 : /gta\s*v\b|grand theft auto v\b/.test(t) ? 4 : 8;
  }
  async function renderRecommendations(data) {
    const section = q('[data-drawer-upsell]');
    if (!section) return;
    const version = ++renderVersion;
    section.hidden=true;
    if(!config.upsell || !data.item_count) return;
    const ids=new Set(data.items.map(p => String(p.product_id)));
    const types=data.items.map(item => isPlus(item));
    const target = types.every(Boolean) ? false : types.every(x => !x) ? true : null;
    const eligible = p => p && !ids.has(String(p.id)) && !isExcluded(p) && p.available !== false &&
      p.variants?.some(v => v.available) && (target === null || isPlus(p) === target);
    let recent=[];
    if(config.recent) recent = (await Promise.all(recentHandles().slice(0,4).map(getProduct))).filter(eligible);
    if(version !== renderVersion) return;
    const configured = (target === true ? config.pools[0] : target === false ? config.pools[1] : [...config.pools[0],...config.pools[1]]).filter(eligible);
    const candidates=[...recent,...configured,...pools.filter(eligible).sort((a,b)=>rank(a)-rank(b))];
    const unique=[...new Map(candidates.map(p=>[String(p.id),p])).values()].slice(0,Number(config.limit)||2);
    recommendationMap=new Map(unique.map(p=>[String(p.id),p]));
    if(!unique.length) return;
    q('#YGUpsellTitle').textContent=target === true ? 'Añade PlayStation Plus' : target === false ? 'Encuentra tu próximo juego' : 'También te puede interesar';
    q('[data-drawer-recommendations]').innerHTML = unique.map(p => {
      const variants=p.variants.filter(v=>v.available);
      const image=typeof p.featured_image === 'string' ? p.featured_image : p.featured_image?.src || p.images?.[0]?.src || p.images?.[0];
      const id=String(p.id);
      const min=Math.min(...variants.map(v=>v.price));
      return '<div class="yg-drawer__recommendation">'+(image ? '<a href="'+escape(productUrl(p))+'"><img src="'+escape(image)+'" alt="'+escape(p.title)+'" width="52" height="68" loading="lazy"></a>' : '<div></div>')+
        '<div><a class="yg-drawer__name" href="'+escape(productUrl(p))+'">'+escape(p.title)+'</a>'+
        '<p class="yg-drawer__recommendation-price" data-recommend-price="'+id+'">'+(variants.length>1?'Desde ':'')+money(min)+'</p>'+
        (variants.length>1 ? '<select data-recommend-variant="'+id+'" aria-label="Elegir versión de '+escape(p.title)+'"><option value="">Elige tu versión</option>'+variants.map(v=>'<option value="'+v.id+'">'+escape(v.title)+' · '+money(v.price)+'</option>').join('')+'</select>' : '')+
        '<button type="button" data-recommend-add="'+id+'">'+(variants.length>1?'Elegir versión':'Añadir al carrito')+'</button></div></div>';
    }).join('');
    section.hidden=false;
    setBusy(pending > 0);
  }
  dialog.addEventListener('change',event => {
    const el=event.target;
    if(el.matches('input[data-line-key]')) {
      const qty=Number(el.value);
      if(!Number.isInteger(qty)||qty<0) { renderCart(cart); return; }
      change(el.dataset.lineKey,qty);
    }
    if(el.matches('[data-recommend-variant]')) {
      const p=recommendationMap.get(el.dataset.recommendVariant);
      const v=p?.variants.find(v=>String(v.id)===el.value);
      if(v) q('[data-recommend-price="'+p.id+'"]').textContent=money(v.price);
      const button=q('[data-recommend-add="'+p.id+'"]');
      if(button) button.textContent=v ? 'Añadir al carrito' : 'Elegir versión';
    }
  });
  dialog.addEventListener('click',event => {
    const changeButton=event.target.closest('button[data-line-key]');
    if(changeButton) change(changeButton.dataset.lineKey,Number(changeButton.dataset.quantity));
    const button=event.target.closest('[data-recommend-add]');
    if(!button) return;
    const p=recommendationMap.get(button.dataset.recommendAdd);
    if(!p) return;
    const select=q('[data-recommend-variant="'+p.id+'"]');
    const variant=select ? p.variants.find(v=>String(v.id)===select.value) : p.variants.find(v=>v.available);
    if(!variant) { select?.focus(); return; }
    add({items:[{id:variant.id,quantity:1}]}).catch(error=>setStatus(error.message));
  });
  document.addEventListener('click',event => {
    const link=event.target.closest('#yg-cart-btn, [data-yg-cart-open]');
    if(!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if(config.drawer) { event.preventDefault(); open(); }
  });
  const formsBusy=new WeakSet();
  document.addEventListener('submit',event => {
    const form=event.target;
    if(!(form instanceof HTMLFormElement) || form.matches('.ygp-form') || !/\/cart\/add(?:\.js)?$/.test(new URL(form.action,location.href).pathname)) return;
    if(event.defaultPrevented) return;
    event.preventDefault();
    if(formsBusy.has(form)) return;
    formsBusy.add(form);
    const button=event.submitter;
    if(button) button.disabled=true;
    add(new FormData(form),{checkout:button?.name==='checkout'}).catch(error=>{ openShell(); setStatus(error.message); }).finally(()=>{formsBusy.delete(form); if(button)button.disabled=false;});
  });
  window.YouGamesCart={open,close,refresh,add,change};
  window.YouGamesOpenCartDrawer=()=>open();
})();
